export default () => {
    if (typeof document === 'undefined') return null;
    const cookieIdentifier = `_im_clickid`;
    document.cookie = cookieIdentifier + '=; Max-Age=0; path=/';
};
